import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent"
import IconButton from "@material-ui/core/IconButton"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import Alert from "@material-ui/lab/Alert"
import Divider from "@material-ui/core/Divider"
import CircularProgress from "@material-ui/core/CircularProgress"
import { useStyles } from "./styles"
import { useTranslations } from "./use-translations"
import { useConfirmDeleteAccount } from "./use-confirm-delete-account"
import { UserViewModel } from "../../api/user"
import { AlertTriangle, X } from "react-feather"

const AccountDeletionConfirmationDialog = ({ user }: { user: UserViewModel }) => {
  const classes = useStyles()
  const translations = useTranslations()

  const {
    dialogOpen,
    openDialog,
    closeDialog,
    confirmAndCloseDialog,
    confirmationText,
    confirmPassword,
    setConfirmationText,
    setConfirmPassword,
    isDeleting,
    disableDeletion,
  } = useConfirmDeleteAccount({
    deleteErrorMessage: translations.deleteErrorMessage,
  })

  if (!dialogOpen) {
    return (
      <div style={{ marginTop: 8 }}>
        <Button
          variant="outlined"
          color="secondary"
          size="small"
          className={classes.deleteAccountButton}
          onClick={openDialog}
        >
          {translations.deleteAccountButtonLabel}
        </Button>
      </div>
    )
  }

  return (
    <Dialog open={dialogOpen} onClose={closeDialog}>
      <DialogTitle id="confirm-organisation-deletion-dialog">
        {translations.deleteAccountConfirmationDialogTitle}
        <IconButton aria-label="close" className={classes.deleteAccountDialogCloseButton} onClick={closeDialog}>
          <X size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.deleteAccountDialogContent}>
        <Alert className={classes.deleteAccountDialogAlert} severity="warning" icon={<AlertTriangle size={20} />}>
          {translations.deleteAccountConfirmationDialogAlertText}
        </Alert>
        <Typography>{translations.deleteAccountConfirmationDialogText}</Typography>
      </DialogContent>
      <Divider />
      <footer className={classes.deleteAccountDialogFooter}>
        <Typography variant="subtitle1" className={classes.userInfoSection}>
          {`${translations.deleteAccountDialogUserInfoText}: `}
          <br />
          {`${translations.usernameText}: `}
          <strong>{user?.fullname}</strong>
          {" , "}
          {`${translations.emailText}: `}
          <strong>{user?.email}</strong>
        </Typography>
        <Divider />
        <Typography variant="subtitle1">
          <strong>{`${translations.deleteAccountConfirmationPasswordLabel}`}</strong>
        </Typography>
        <TextField
          type="password"
          margin="dense"
          variant="outlined"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          fullWidth
        />
        <Typography variant="subtitle1">
          <strong>{`${translations.deleteAccountExtraConfirmationTextLabel}: 'delete my account'`}</strong>
        </Typography>
        <TextField
          margin="dense"
          variant="outlined"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          fullWidth
        />
        <Button
          variant="contained"
          size="small"
          onClick={confirmAndCloseDialog}
          disabled={disableDeletion}
          startIcon={isDeleting ? <CircularProgress size={22.75} /> : null}
          fullWidth
        >
          {isDeleting ? "" : translations.deleteAccountButtonLabel}
        </Button>
      </footer>
    </Dialog>
  )
}

export default AccountDeletionConfirmationDialog
